module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-list-wrapper"
  }, [_c('transition-group', {
    staticClass: "ui very compact table",
    attrs: {
      "name": "fadeDown",
      "mode": "out-in",
      "tag": "table"
    }
  }, _vm._l((_vm.paginatedProducts), function(product) {
    return _c('tr', {
      key: product.productId,
      on: {
        "click": function($event) {
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_c('td', {
      staticClass: "ui collapsing"
    }, [_c('img', {
      staticClass: "ui image tiny",
      attrs: {
        "src": product.largeImageUrl,
        "qqqstyle": "max-height:140px; max-width:100%; height:auto; width:auto; margin:5px auto 1px;"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: " four wide"
    }, [_c('div', {
      staticStyle: {
        "max-height": "5.5em",
        "overflow": "hidden"
      }
    }, [(product.productGroupProductIds.length > 1) ? _c('span', {
      staticClass: "ui mini circular grey label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      },
      attrs: {
        "data-content": product.productGroupProductIds.length + ' variations in this group',
        "data-position": "top left",
        "data-variation": "mini"
      }
    }, [_vm._v("\n          " + _vm._s(product.productGroupProductIds.length) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('i', {
      class: '' + product.marketplace.toLowerCase().replace('uk', 'gb') + ' flag'
    }), _vm._v("\n        " + _vm._s(product.productTitle) + "\n      ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [(_vm.reds[product.productGroupId]) ? _c('span', {
      staticClass: "ui red horizontal label",
      staticStyle: {
        "margin-right": "1px",
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(_vm.reds[product.productGroupId]) + " new issue" + _vm._s(_vm.reds[product.productGroupId] > 1 ? 's' : '  '))]) : _vm._e(), _vm._v(" "), (_vm.reds[product.productGroupId] > 0) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.ambers[product.productGroupId]) ? _c('span', {
      staticClass: "ui orange horizontal label",
      staticStyle: {
        "margin": "0 2px 0 0",
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(_vm.ambers[product.productGroupId]) + " new warn.")]) : _vm._e()]), _vm._v(" "), (product.reviewCount !== null) ? _c('td', {
      staticClass: "two wide",
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_vm._l((_vm.starCalc(product.starRating, 'f')), function(n) {
      return _c('i', {
        staticClass: "yellow fitted star icon"
      })
    }), _vm._l((_vm.starCalc(product.starRating, 'h')), function(n) {
      return _c('i', {
        staticClass: "icons"
      }, [_c('i', {
        staticClass: "yellow fitted star outline icon"
      }), _c('i', {
        staticClass: "yellow fitted half star icon"
      })])
    }), _vm._l((_vm.starCalc(product.starRating, 'e')), function(n) {
      return _c('i', {
        staticClass: "yellow fitted star outline icon"
      })
    }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.badReview && _vm.$parent.$parent.worldStore.watchDogs.badReview.items && _vm.$parent.$parent.worldStore.watchDogs.topReview && _vm.$parent.$parent.worldStore.watchDogs.topReview.items && _vm.$parent.$parent.worldStore.watchDogs.badReview.items.hasOwnProperty(product.productId) && _vm.$parent.$parent.worldStore.watchDogs.topReview.items.hasOwnProperty(product.productId) && ((_vm.$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].status == 2 && _vm.$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].issueStatus == 0) || (_vm.$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].status == 2 && _vm.$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].issueStatus == 0))) ? _c('i', {
      staticClass: "fitted red warning icon"
    }) : (_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.badReview && _vm.$parent.$parent.worldStore.watchDogs.badReview.items && _vm.$parent.$parent.worldStore.watchDogs.topReview && _vm.$parent.$parent.worldStore.watchDogs.topReview.items && _vm.$parent.$parent.worldStore.watchDogs.badReview.items.hasOwnProperty(product.productId) && _vm.$parent.$parent.worldStore.watchDogs.topReview.items.hasOwnProperty(product.productId) && ((_vm.$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].status == 1 && _vm.$parent.$parent.worldStore.watchDogs.badReview.items[product.productId].issueStatus == 0) || (_vm.$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].status == 1 && _vm.$parent.$parent.worldStore.watchDogs.topReview.items[product.productId].issueStatus == 0))) ? _c('i', {
      staticClass: "fitted orange warning icon"
    }) : _c('i', [_vm._v("   ")]), _vm._v("\n\n      " + _vm._s(product.reviewCount) + " " + _vm._s(product.reviewCount > 1 ? 'ratings' : 'rating') + "\n    ")], 2) : _c('td', {}, [_c('i', {
      staticClass: "yellow empty star icon",
      staticStyle: {
        "margin-right": "1px"
      }
    }), _vm._v("\n        Review data not avail. yet\n    ")]), _vm._v(" "), (product.ageHours > -1) ? _c('td', {
      staticClass: "collapsing",
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_c('div', {
      attrs: {
        "data-tooltip": 'Today: ' + product.salesTodayDate + ' ' + _vm.toMonth(product.salesTodayMonth) + ' in Amazon ' + product.marketplace + ' time'
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.salesCountTotal(product.productGroupProductIds, 'y')))]), _vm._v(" units sold ystd. "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.salesCountTotal(product.productGroupProductIds, 't')))]), _vm._v(" so far today (" + _vm._s(product.marketplace) + ")\n      ")])]) : _c('td', {}, [_c('i', {
      staticClass: "dollar icon",
      staticStyle: {
        "margin-right": "1px"
      }
    }), _vm._v("\n        Sales data not avail. yet\n    ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "chartbutton ui right floated basic brown button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$parent.$parent.$refs.chartModal.open(product, null)
        }
      }
    }, [_c('i', {
      staticClass: "bar chart icon",
      staticStyle: {
        "margin": "0"
      }
    })])]), _vm._v(" "), (product.bsrRank !== null) ? _c('td', {
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_vm._v("\n      BSR\n      "), _c('small', {
      staticStyle: {
        "color": "#aaa"
      }
    }, [_vm._v("(24h avg.) ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#a291fb",
        "font-weight": "bold"
      }
    }, [_vm._v("\n        " + _vm._s(product.bsrRank) + "\n      ")])]) : _vm._e(), _vm._v(" "), (product.productGroupProductIds.length > 1 && _vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId]) ? _c('td', {
      staticClass: "three wide"
    }, [(_vm.stockReds[product.productGroupId] == 0 && _vm.stockAmbers[product.productGroupId] == 0) ? _c('span', [_c('span', {
      staticClass: "ui mini circular grey label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "cursor": "pointer"
      },
      attrs: {
        "data-content": product.productGroupProductIds.length + ' variations in this group',
        "data-position": "top left",
        "data-variation": "mini"
      }
    }, [_vm._v("\n            " + _vm._s(product.productGroupProductIds.length) + "\n          ")]), _vm._v(" "), _c('small', [_vm._v("SKUs")])]) : _c('span', [_c('i', {
      staticClass: "brown warehouse icon"
    }), _vm._v("\n          Stock:\n          "), (_vm.stockReds[product.productGroupId]) ? _c('div', {
      staticClass: "ui tiny compact circular red label",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "warning icon"
    }), _vm._v(_vm._s(_vm.stockReds[product.productGroupId]))]) : _vm._e(), _vm._v(" "), (_vm.stockAmbers[product.productGroupId]) ? _c('div', {
      staticClass: "ui tiny compact circular orange label",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "warning icon"
    }), _vm._v(_vm._s(_vm.stockAmbers[product.productGroupId]))]) : _vm._e(), _vm._v("\n          of "), _c('span', {
      staticClass: "ui mini circular  label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "cursor": "pointer"
      },
      attrs: {
        "data-content": product.productGroupProductIds.length + ' variations in this group',
        "data-position": "top left",
        "data-variation": "mini"
      }
    }, [_vm._v("\n            " + _vm._s(product.productGroupProductIds.length) + "\n          ")]), _vm._v(" "), _c('small', [_vm._v("SKUs")])])]) : _vm._e(), _vm._v(" "), (product.productGroupProductIds.length === 1 && _vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId]) ? _c('td', {
      staticClass: "three wide",
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [(_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId] && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 0) ? _c('i', {
      staticClass: "green checkmark icon"
    }) : _vm._e(), _vm._v(" "), (_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId] && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 1) ? _c('i', {
      staticClass: "orange circle warning icon"
    }) : _vm._e(), _vm._v(" "), (_vm.$parent.$parent.worldStore.watchDogs && _vm.$parent.$parent.worldStore.watchDogs.inventory && _vm.$parent.$parent.worldStore.watchDogs.inventory.items && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId] && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 2) ? _c('i', {
      staticClass: "red circle warning checkmark icon"
    }) : _vm._e(), _vm._v("\n\n        " + _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message ? _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/,.* (\d+)\..*/gi, ' ($1 avail.)').replace(/Total in stock/gi, 'Stock') : '') + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message ? _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/.*\((.+)\)/gi, '$1').replace(/Total in stock/gi, 'Stock').replace(/No alert threshold set;?/, '') : '') + "\n    ")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment",
    staticStyle: {
      "margin-top": "20px",
      "background-color": "#f8f8f8",
      "border": "1px solid #ddd"
    }
  }, [_c('div', {
    staticClass: "ui pagination menu"
  }, [_c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage === 0
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), _vm._l((Math.min(5, _vm.totalPages)), function(page) {
    return _c('a', {
      key: page,
      staticClass: "item",
      class: {
        active: _vm.currentPage === _vm.getPageNumber(page)
      },
      on: {
        "click": function($event) {
          _vm.goToPage(_vm.getPageNumber(page))
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.getPageNumber(page) + 1) + "\n    ")])
  }), _vm._v(" "), _c('a', {
    staticClass: "item",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "ui small message",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n    Showing page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.totalPages) + " \n    (" + _vm._s(_vm.totalItems) + " total products)\n    "), _c('br'), _vm._v("\n    DEBUG: groupedProducts=" + _vm._s(_vm.groupedProducts ? _vm.groupedProducts.length : 'undefined') + ", \n    itemsPerPage=" + _vm._s(_vm.itemsPerPage) + ", \n    totalPages=" + _vm._s(_vm.totalPages) + "\n  ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dd6efe24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductList.vue
// module id = 816
// module chunks = 2